import { KEY_SHIFT_LEFT, KEY_SHIFT_RIGHT } from '@/constants';

export default event => {
  return event.shiftKey || [KEY_SHIFT_LEFT, KEY_SHIFT_RIGHT].includes(event.code);
};
